import services from "../../services";
import Vue from "vue";

const strict = true;
const defaultComponentId = "defaultComponentId";

const state = {
  regions: {},
  componentIds: [defaultComponentId]
};

const getters = {
  regions: state => id => {
    if (id) {
      return state.regions[id];
    } else {
      return state.regions[defaultComponentId];
    }
  }
};

const mutations = {
  reset(state) {
    state.regions = {};
    state.componentIds = [defaultComponentId];
  },
  setup(state, ids) {
    state.regions = {};
    if (ids) {
      state.componentIds = ids;
    } else {
      state.componentIds = [defaultComponentId];
    }
  },
  regionsLoaded(state, regions) {
    let id;
    for (id in state.componentIds) {
      Vue.set(state.regions, state.componentIds[id], regions);
    }
  },
  errorLoadingRegions(state) {
    state.regions = {};
  }
};

const actions = {
  async getRegions({ commit }, ids) {
    try {
      commit("setup", ids);
      let regions = await services.addressService.getRegions(commit);
      commit("regionsLoaded", regions);
    } catch (error) {
      commit("error/setError", error, { root: true });
    }
  }
};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
